import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { StorageEnum } from '../enums/StorageEnum';
import { LocalStorageService } from './../../services/local-storage-service';

const C_TOKEN_ADMINISTRADOR = "access_token";

@Injectable({
  providedIn: 'root',
})
export class InjectTokenInterceptor implements HttpInterceptor {
  constructor(
    private LocalStorageService: LocalStorageService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.LocalStorageService.get(StorageEnum.TOKEN);

    if (token !== null) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(req);
  }
}
